<template>
	<v-text-field
		outline
		:label="label"
		v-model="color"
		:name="name"
		browser-autocomplete="off"
		:hide-details="!regexCheck"
		:error="regexCheck.length > 0"
		:error-messages="regexCheck"
		:maxlength="colorLength"
		@keydown="checkColor"
		@blur="addHash"
	>
		<template v-slot:append>
			<v-menu top offset-y offset-x left content-class="color-picker" :close-on-content-click="false">
				<div :style="`background-color: ${color}`" slot="activator" class="color-picker__swatch"></div>

				<color-picker v-model="color"></color-picker>
			</v-menu>
		</template>
	</v-text-field>
</template>

<script>
import { mapGetters } from "vuex";
import { Sketch } from "vue-color";

export default {
	data() {
		return {
			colorLength: 7,
			regex: /^#?[0-9A-Fa-f]{6}$/g,
			numeric: [48, 49, 50, 51, 52, 53, 54, 55, 56, 57],
			alpha: [65, 66, 67, 68, 69, 70],
			whiteList: [8, 9, 13, 16, 17, 37, 38, 39, 40, 91],
			blackList: [
				16,
				71,
				72,
				73,
				74,
				75,
				76,
				77,
				78,
				79,
				80,
				81,
				82,
				83,
				84,
				85,
				86,
				87,
				88,
				89,
				90,
				187,
				188,
				189,
				190,
				191,
				192,
				219,
				220,
				221,
				186,
				222
			]
			// colors: "#194d33"
		};
	},

	components: {
		"color-picker": Sketch
	},

	props: {
		label: {
			default: "Color",
			type: String
		},

		name: {
			default: "color",
			type: String
		},

		value: {
			default: "#000000",
			type: String
		}
	},

	computed: {
		color: {
			get() {
				return this.value;
			},
			set(value) {
				if (typeof value !== "string") {
					value = value.hex;
				}

				this.setColor(value);
				this.$emit("input", value);
			}
		},

		hasHash() {
			return this.color.startsWith("#");
		},

		regexCheck(a) {
			return /^#?[0-9A-Fa-f]{6}$/g.test(this.color)
				? ""
				: "Invalid Hexadecimal Color";
		}
	},

	methods: {
		addHash() {
			if (!this.color.startsWith("#")) {
				this.color = "#" + this.color;
			}
		},

		checkColor(e) {
			const charCode = e.keyCode;
			const cursorPosition = e.target.selectionStart;

			if ((!this.hashHash && cursorPosition === 0) || this.hasHash) {
				// If cursor is at position 0 and color has no  # OR if color has #
				this.colorLength = 7;
			} else {
				this.colorLength = 6;
			}

			if (!e.metaKey) {
				if (this.blackList.includes(charCode)) {
					e.preventDefault();
				}

				if (this.numeric.includes(charCode) && e.shiftKey) {
					if (charCode !== 51) {
						e.preventDefault();
					}
					if (cursorPosition !== 0 || this.hasHash) {
						e.preventDefault();
					}
				}

				// this.hasHash

				// if (cursorPosition !== 0 && charCode === 51 && e.shiftKey) {
				// 	e.preventDefault();
				// }
			}
		},

		setColor(color) {
			if (this.regex.test(color)) {
				this.$vuetify.theme[this.name] = color;
			}
		}
	}
};
</script>
